import { render, staticRenderFns } from "./VAspectRatioBox.vue?vue&type=template&id=10d807a3&scoped=true&"
import script from "./VAspectRatioBox.vue?vue&type=script&lang=ts&"
export * from "./VAspectRatioBox.vue?vue&type=script&lang=ts&"
import style0 from "./VAspectRatioBox.vue?vue&type=style&index=0&id=10d807a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d807a3",
  null
  
)

export default component.exports